import Position from './position';

export default class Preloader {
  // This method will be called when a Wallpaper is attempting
  // to preload itself. Every wallpaper type that we support
  // should have it's own preload options.
  static load(media, parent) {
    return new Promise((resolve, reject) => {
      switch (media.type) {
        case 'image':
          return Preloader.loadImage(media, parent, resolve, reject);

        case 'html5':
          return Preloader.loadHTML5(media, parent, resolve, reject);

        default:
          throw 'UnsupportedMediaType';
      }
    });
  }

  // Image preloading is fairly straight-forward, a method
  // used through-out the ages. Load the image and have some
  // events on it - and make sure caching rules on the CDN
  // are set correctly.
  static loadImage(media, parent, resolve, reject) {
    let image = new Image();

    // It failed! :(
    image.onerror = () => {
      image = null;
      reject();
    };

    // It succeeded! :)
    image.onload = () => {
      image.onload = null;
      media.setNode(image);
      media.appendTo(parent);
      resolve();
    };

    // Actually load the file, the order here
    // was important because if the image was
    // cached it would otherwise not trigger events
    image.src = media.fullPath;
  }

  // HTML preloading is slightly more complicated, but we manage.
  static loadHTML5(media, parent, resolve, reject) {
    const frame = document.createElement('iframe');
    let source = media.fullPath;

    // The HTML5 Advert needs to know the parent frame origin
    // for secure cross-frame messaging.
    source +=
      (source.match(/\?/) ? '&' : '?') +
      '_origin=' +
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');

    // Configure the iframe
    frame.setAttribute('src', source);
    frame.setAttribute('border', 0);
    frame.setAttribute('scrolling', 'no');
    frame.setAttribute('frameborder', 0);
    frame.setAttribute('allow', 'autoplay; camera');

    // Wait for the frame to be completed
    frame.onload = () => {
      frame.onload = null;
      resolve();
    };

    // It could of course fail.. hopefully it won't though.
    frame.onerror = () => {
      media.remove();
      reject();
    };

    // Already set the node here.
    media.setNode(frame);

    // Prepare (which will position it and hide it)
    Position.prepare(media);

    // Append to parent so it starts loading
    media.appendTo(parent);
  }
}
